import { Component, ErrorInfo, ReactNode } from 'react';
import NoMatch404 from '@pages/accessManagement/NoMatch404';
import { EventTypes, useFirebaseHook } from '@utils/firebaseUtils';

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

// Firebase hook used via a wrapper ref so it is not called inside the class body.
// ErrorBoundary is a class component and cannot call hooks directly.
let _firebaseRef: ReturnType<typeof useFirebaseHook> | null = null;
function FirebaseInitialiser() {
  _firebaseRef = useFirebaseHook();
  return null;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
    _firebaseRef?.fireEvent(EventTypes.app_crashed, { error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return <NoMatch404 translationKey1="main.error_captured" translationKey2="main.error_occurred" />;
    }

    return (
      <>
        <FirebaseInitialiser />
        {this.props.children}
      </>
    );
  }
}

export default ErrorBoundary;
